/**
 * Display helpers for Vesta coalesced estimated cash to close (loan.estimatedCashToClose).
 * Sign: negative = cash to borrower; positive = cash from borrower (per LOS convention).
 */
import { fmtDollar } from './formatters';

/**
 * @param {number | null | undefined} val
 * @returns {{ label: string, amountDisplay: string, emphasis: 'borrower' | 'fromBorrower' | 'neutral' } | null}
 */
export function getEstimatedCashToCloseDisplay(val) {
  if (val == null || Number.isNaN(Number(val))) return null;
  const n = Number(val);
  const abs = fmtDollar(Math.abs(n));
  if (n < 0) {
    return { label: 'Cash to borrower', amountDisplay: abs, emphasis: 'borrower' };
  }
  if (n > 0) {
    return { label: 'Cash from borrower', amountDisplay: abs, emphasis: 'fromBorrower' };
  }
  return { label: 'Cash to close', amountDisplay: fmtDollar(0), emphasis: 'neutral' };
}

/**
 * Single-line string for doc order / tables (e.g. "Cash from borrower: $12,345.67").
 * @param {number | null | undefined} val
 * @returns {string}
 */
export function formatEstimatedCashToCloseLine(val) {
  const d = getEstimatedCashToCloseDisplay(val);
  if (!d) return '—';
  return `${d.label}: ${d.amountDisplay}`;
}
